export const iconFontAwesomeDevicesHardwareLaptopFile = (
	<i className="fa-solid fa-laptop-file"></i>
);
